import { useStafferTosAcceptanceRetrieve, useStafferTosAcceptanceUpdate } from "@sidegigllc/api/client";

export function useToSAcceptance() {
  return useStafferTosAcceptanceRetrieve("me", { query: { staleTime: Number.POSITIVE_INFINITY, retry: false } });
}

export function useUpdateToSAcceptance() {
  const tosAcceptance = useToSAcceptance();
  return useStafferTosAcceptanceUpdate({ mutation: { onSuccess: () => tosAcceptance.refetch() } });
}
